import { Injectable } from '@angular/core';

@Injectable()
export class SvgExportService {
  constructor() {}

  public exportStyledSVG(domString, dataScheme) {
    // let data = new XMLSerializer().serializeToString(oDOM);
    domString = domString.replace(/(\w+)?:?xlink=/g, 'xmlns:xlink='); // Fix root xlink without namespace
    domString = domString.replace(/NS\d+:href/g, 'xlink:href'); // Safari NS namespace fix
    domString = domString.replace(/<!--[\s\S]*?-->/g, ''); // remove comments

    // add xml declaration
    domString = '<?xml version="1.0" standalone="no"?>\r\n' + domString;

    // convert svg source to URI domString scheme.
    domString = dataScheme + encodeURIComponent(domString);

    return domString;
  }

  publicAddStyle(DOMelement) {
    const oDOM = DOMelement.cloneNode(true);
    this.getElementStyle(oDOM, DOMelement, true);
    return new XMLSerializer().serializeToString(oDOM);
  }

  public getElementStyle(ParentNode, OrigData, root = false) {
    const styles = [
      'padding',
      'padding-bottom',
      'padding-top',
      'padding-left',
      'padding-right',
      'margin',
      'margin-bottom',
      'margin-top',
      'margin-left',
      'margin-right',
      'border',
      'border-bottom',
      'border-top',
      'border-left',
      'border-right',
      'border-collapse',
      'border-radius',
      'border-spacing',
      'flex-direction',
      'justify-content',
      'grid-template-columns',
      'box-shadow',
      'left',
      'right',
      'top',
      'bottom',
      'position',
      'max-width',
      'min-width',
      'font-size',
      'font-family',
      'font-weight',
      'color',
      'background-color',
      'text-shadow',
      'display',
      'text-align',
      'text-anchor',
      'text-transform',
      'white-space',
      'list-style',
      'line-height',
      'fill',
      'stroke',
      'stroke-width',
      'transform',
      'transform-origin',
      'float',
      'vertical-align',
      'box-sizing',
      'zoom'
    ];

    const Children = ParentNode.childNodes;
    const OrigChildDat = OrigData.childNodes;

    for (let cd = 0; cd < Children.length; cd++) {
      const Child = Children[cd];

      const TagName = Child.tagName;

      if (typeof TagName === 'undefined') {
        continue;
      }

      // skip noexport
      if (typeof Child.attributes['noexport'] !== 'undefined') {
        Child.setAttribute('style', 'display: none');
        continue;
      }

      // fetch relevant styles
      const StyleDef = window.getComputedStyle(OrigChildDat[cd]);

      let styleString = '';
      for (let st = 0; st < styles.length; st++) {
        styleString += styles[st] + ':' + StyleDef.getPropertyValue(styles[st]) + '; ';
      }
      styleString += this.getElementSize(OrigChildDat[cd]);

      Child.setAttribute('style', styleString);

      // if it's a parent node, go into childs
      if (Child.childNodes.length > 0) {
        this.getElementStyle(Child, OrigChildDat[cd]);
      }
    }

    if (root) {
      // add parent style
      const SvgStyleDef = window.getComputedStyle(ParentNode);
      const SvgStyleString = SvgStyleDef.cssText + this.getElementSize(ParentNode);
      ParentNode.setAttribute('style', SvgStyleString);
    }
  }

  private getElementSize(element) {
    let h = null;
    if (typeof element.attributes.height !== 'undefined') {
      h = '';
    } else {
      h = element.offsetHeight;
      if (typeof h === 'undefined') {
        h = element.clientHeight;
      }
      h = 'height: ' + h + 'px; ';
    }

    let w = null;
    if (typeof element.attributes.width !== 'undefined') {
      w = '';
    } else {
      w = element.offsetWidth;
      if (typeof w === 'undefined') {
        w = element.clientWidth;
      }
      w = 'width: ' + w + 'px; ';
    }

    return w + h;
  }

  public wrapElementInSVG(DOMelement, domW, domH) {
    const styledDom = this.publicAddStyle(DOMelement);

    const wrapper =
      '<svg xmlns="http://www.w3.org/2000/svg" width="' +
      domW +
      '" height="' +
      domH +
      '">' +
      '<foreignObject width="100%" height="100%">' +
      '<div xmlns="http://www.w3.org/1999/xhtml">' +
      styledDom +
      '</div>' +
      '</foreignObject>' +
      '</svg>';

    return wrapper;
  }

  private downloadURI(uri, name) {
    const link = document.createElement('a');
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // delete link;
  }

  public save(elemId, filename = null) {
    if (!filename) {
      filename = elemId;
    }

    const domElement = document.getElementById(elemId);
    const domW = domElement.clientWidth;
    const domH = domElement.clientHeight;

    let domString: string;

    if (domElement.tagName.toLowerCase() !== 'svg') {
      domString = this.wrapElementInSVG(domElement, domW, domH);
    } else {
      domString = this.publicAddStyle(domElement);
    }
    const svgURI = this.exportStyledSVG(domString, 'data:image/svg+xml;charset=utf-8,');

    this.downloadURI(svgURI, filename + '.svg');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/svg-export.service.ts